export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative flex min-h-[600px] w-full items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Vibrant%20stylized%20anime%20manga%20cityscape%20illustration%20at%20golden%20sunset%20with%20soaring%20skyline%20and%20floating%20comic%20panels%2C%20warm%20orange%20and%20deep%20crimson%20gradient%20sky%2C%20dynamic%20composition%20with%20action%20lines%20and%20speed%20effects%2C%20artistic%20colorful%20graphic%20novel%20backdrop%2C%20no%20text%2C%20clean%20and%20cinematic%20widescreen%20illustration&width=1600&height=900&seq=hero-manga-bg&orientation=landscape"
        alt="飞飞漫画网极速加载翻页流畅的漫画阅读背景插画"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 py-24 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-4 py-1.5 text-xs font-medium tracking-wide text-white backdrop-blur">
          <i className="ri-flashlight-line"></i>
          极速加载 · 翻页流畅 · 夜间护眼
        </span>

        <h1 className="font-heading mt-6 text-4xl leading-tight text-white md:text-6xl">
          飞飞漫画网，畅快阅读不等待
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-white/85 md:text-lg">
          极速加载让你打开即看，翻页流畅不卡顿，夜间模式护眼更舒适。
          海量热门漫画，无需登录，随时随地畅快看漫画。
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <button
            type="button"
            onClick={() => scrollTo('popular')}
            className="whitespace-nowrap w-full sm:w-auto rounded-md bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            开始看漫画
            <i className="ri-arrow-right-line ml-1.5"></i>
          </button>
          <button
            type="button"
            onClick={() => scrollTo('features')}
            className="whitespace-nowrap w-full sm:w-auto rounded-md border border-white/40 bg-white/10 px-7 py-3 text-sm font-semibold text-white backdrop-blur transition-colors hover:bg-white/20 cursor-pointer"
          >
            <i className="ri-moon-clear-line mr-1.5"></i>
            体验夜间模式
          </button>
        </div>

        <div className="mx-auto mt-12 grid max-w-3xl grid-cols-3 gap-4">
          {[
            { num: '3万+', label: '在线漫画' },
            { num: '8亿+', label: '累计阅读' },
            { num: '1200万', label: '漫画爱好者' },
          ].map((s) => (
            <div
              key={s.label}
              className="rounded-lg border border-white/15 bg-white/10 px-3 py-4 text-center backdrop-blur"
            >
              <div className="font-heading text-2xl text-accent-400 md:text-3xl">{s.num}</div>
              <div className="mt-1 text-xs text-white/75">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}